var list1 = [];
var lydz = {
  yongcheshenqing: [
    {
      title: "单位名称",
      key: "groupId",
      key1: "groupName",
      type: "selectGroup",
      required: true,
      minWidth: 150,
      maxWidth: 260
    },
    {
      title: "计划发车地点",
      key: "planStartAdd",
      keyX: "planStartX",
      keyY: "planStartY",
      type: "selectAddMap",
      list1: list1,
      required: true,
      clearable: true,
      minWidth: 200,
      maxWidth: 300
    },
    {
      title: "计划发车时间",
      key: "planStartTime",
      key2: "planStartTime2",
      type: "lyyymmdd",
      formate: "datetime",
      clearable: false,
      required: true,
      show: "yymmdd",
      minWidth: 130
    },
    {
      title: "计划送达地点",
      key: "planReachAdd",
      keyX: "planReachX",
      keyY: "planReachY",
      type: "selectAddMap",
      required: true,
      clearable: true,
      minWidth: 200,
      maxWidth: 300,
      list1: list1
    },
    {
      title: "计划送达时间",
      key: "planReachTime",
      key2: "planReachTime2",
      type: "lyyymmdd",
      formate: "datetime",
      clearable: false,
      required: true,
      show: "yymmdd",
      minWidth: 130
    },
    {
      title: "计划还车时间",
      key: "planEndTime",
      key2: "planEndTime2",
      type: "lyyymmdd",
      formate: "datetime",
      clearable: false,
      required: true,
      show: "yymmdd",
      minWidth: 130
    },
    {
      title: "车辆类型",
      key: "type",
      type: "Select",
      selectItems: ["轿车", "商务车", "中巴", "货车", "越野车", "皮卡"]
    },
    {
      title: "用车人",
      slotForm: "passengers",
      slot: "passengers"
    },

    {
      title: "用车事由",
      key: "des",
      type: "Input",
      //selectItems: ["拜访客户", "外出公事", "接送客户", "其他"],
      clearable: false,
      allowCreate: true
    },
    {
      title: "用车人数",
      key: "number",
      min: 1,
      type: "InputNumber",
      required: false
    },
    /* {
      title: "运输重量/吨",
      key: "weight",
      type: "InputNumber",
      min: 0,
      required: false
    }, */
    {
      title: "备注信息",
      key: "remark",
      type: "Input",
      type1: "textarea",
      required: false
    }
  ],
  yongcheshenqing1: "/cloud-car-server-dpc/apply/item",
  qianzi: [
    {
      title: "表单号",
      key: "title",
      key1: "title",
      type: "Input",
      span: 24,
      width: 200,
      readonly: true,
      required: true
    },
    {
      title: "职务",
      key: "job",
      key1: "job",
      type: "Input",
      span: 24,
      width: 200,
      required: true,
      readonly: true
    },
    {
      title: "签字",
      key: "name",
      key1: "name",
      type: "Input",
      span: 24,
      width: 200,
      required: true,
      readonly: true
    },
    {
      title: "处理意见",
      key: "opinion",
      key1: "opinion",
      type: "Input",
      span: 24,
      width: 200,
      required: true
    },
    {
      title: "签字日期",
      key: "time",
      key2: "time2",
      type: "lyyymmdd",
      span: 24,
      width: 200,
      required: true
    },
    {
      title: "手写签名",
      key: "fileList",
      slotForm: "qianming",
      span: 24,
      width: 200,
      required: true
    }
  ],
  jiayou: [
    {
      title: "车牌号",
      key: "carId",
      key1: "carNo",
      type: "selectCar",
      required: true
    },
    /*  {
      title: "审批人",
      key: "shenpirenId",
      key1: "shenpirenName",
      type: "selectUser",
      required: true,
    }, */
    {
      title: "加油量/L",
      key: "refuelVolume",
      type: "InputNumber",
      required: true
    },
    {
      title: "加油金额/元",
      key: "refuelCost",
      type: "InputNumber",
      required: true
    },
    {
      title: "加油里程",
      key: "mileage",
      type: "InputNumber",
      required: true
    },
    {
      title: "加油站",
      key: "refuelStation",
      type: "Input"
    },
    {
      title: "加油日期",
      key: "refuelDate",
      key2: "refuelDate2",
      type: "lyyymmdd",
      required: true
    },
    {
      title: "图片",
      key: "proofList",
      slot: "proofList",
      type: "lyPhoto"
    },
    {
      title: "备注信息",
      key: "remark",
      type: "Input",
      type1: "textarea",
      span: 24
    }
  ],
  jiayou1: "/cloud-common-server-cost/refuel/item",
  weixiu: [
    {
      title: "车牌号",
      key: "carId",
      key1: "carNo",
      type: "selectCar",
      required: true
    },
    {
      title: "维修项目",
      key: "item",
      type: "Input",
      multiple: true,
      required: true
    },
    {
      title: "维修费",
      key: "repairCost",
      type: "InputNumber",
      required: true
    },
    {
      title: "工时费",
      key: "hourlyCost",
      type: "InputNumber",
      required: true
    },

    {
      title: "材料费",
      key: "materialCost",
      type: "InputNumber",
      required: true
    },
    {
      title: "维修店名",
      key: "repairShop",
      type: "Input"
    },
    {
      title: "维修日期",
      key: "repairDate",
      key2: "repairDate2",
      type: "lyyymmdd",
      required: true
    },
    {
      title: "图片",
      key: "proofList",
      slot: "proofList",
      type: "lyPhoto"
    },
    {
      title: "备注信息",
      key: "remark",
      type: "Input",
      type1: "textarea",
      span: 24
    }
  ],
  weixiu1: "/cloud-common-server-cost/repair/item",
  baoyang: [
    {
      title: "车牌号",
      key: "carId",
      key1: "carNo",
      type: "selectCar",
      required: true
    },
    {
      title: "保养项目",
      key: "item",
      type: "Input",
      required: true
    },
    {
      title: "保养费用",
      key: "careCost",
      type: "InputNumber",
      required: true
    },
    {
      title: "保养里程",
      key: "mileage",
      type: "InputNumber",
      required: true
    },
    {
      title: "保养店名",
      key: "careShop",
      type: "Input"
    },
    {
      title: "保养日期",
      key: "careDate",
      key2: "careDate2",
      type: "lyyymmdd",
      required: true
    },
    {
      title: "图片",
      key: "proofList",
      slot: "proofList",
      type: "lyPhoto"
    },
    {
      title: "备注信息",
      key: "remark",
      type: "Input",
      type1: "textarea",
      span: 24
    }
  ],
  baoyang1: "/cloud-common-server-cost/care/item",
  baoxian: [
    {
      title: "选择车辆",
      key: "carId",
      key1: "carNo",
      type: "selectCar",
      required: true,
      noTable: true
    },
    /*  {
      title: "全年保险",
      key: "annualCost",
      type: "InputNumber",
      required: false,
    },
    {
      title: "车损险",
      key: "cdiCost",
      type: "InputNumber",
      required: true,
    }, */
    {
      title: "保险费用",
      key: "insurCost",
      type: "InputNumber",
      required: true
    },
    {
      title: "保险日期",
      key: "insurDate",
      key2: "insurDate2",
      type: "lyyymmdd",
      required: true
    },
    {
      title: "到期日期",
      key: "expireDate",
      key2: "expireDate2",
      type: "lyyymmdd",
      required: true,
      noTable: true
    },
    {
      title: "图片",
      key: "proofList",
      slot: "proofList",
      type: "lyPhoto",
      required: false
    },
    {
      title: "备注",
      key: "remark",
      type: "Input",
      required: false
    }
  ],
  baoxian1: "/cloud-common-server-cost/insur/item",
  weizhang: [
    {
      title: "车牌号",
      key: "carId",
      key1: "carNo",
      type: "selectCar",
      required: true
    },
    {
      title: "交警部门",
      key: "tpDp",
      type: "Input"
    },
    {
      title: "违章费用",
      key: "peccancyCost",
      type: "InputNumber",
      required: true
    },
    {
      title: "扣分",
      key: "score",
      type: "InputNumber",
      required: true
    },
    {
      title: "违章日期",
      key: "peccancyDate",
      key2: "peccancyDate2",
      type: "lyyymmdd",
      required: true
    },
    {
      title: "图片",
      key: "proofList",
      slot: "proofList",
      type: "lyPhoto"
    },
    {
      title: "备注信息",
      key: "remark",
      type: "Input",
      type1: "textarea",
      span: 24
    }
  ],
  weizhang1: "/cloud-common-server-cost/peccancy/item",
  qita: [
    {
      title: "车牌号",
      key: "carId",
      key1: "carNo",
      type: "selectCar",
      required: true
    },
    {
      title: "费用类型",
      key: "type",
      type: "Select",
      selectItems: ["过桥费", "停车费", "代驾费", "年审费", "其他费"],
      required: true,
      filterable: true,
      allowCreate: true
    },
    {
      title: "费用金额",
      key: "payCost",
      type: "InputNumber",
      required: true
    },
    {
      title: "收款方",
      key: "payee",
      type: "Input"
    },
    {
      title: "支出日期",
      key: "payDate",
      key2: "payDate2",
      type: "lyyymmdd",
      required: true
    },
    {
      title: "图片",
      key: "proofList",
      slot: "proofList",
      type: "lyPhoto"
    },
    {
      title: "备注信息",
      key: "remark",
      type: "Input",
      type1: "textarea",
      span: 24
    }
  ],
  qita1: "/cloud-common-server-cost/pay/item"
};

export default lydz;



// WEBPACK FOOTER //
// ./src/components/diaodu/forms/fields.js